const CDN_HOST = "https://cdn.primaverasurgical.com";

export default CDN_HOST;
